<template>
  <div class="casino-page">
    <v-layout  class="page-layout">
      <v-flex class="main-column">
        <div class="casino-promotions-container">
          <ps-promotion :section="'casino'"></ps-promotion>
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import PsPromotion from '@/components/pages/PromotionsPage.vue'

export default {
  name: 'casinoPromotion',

  mixins: [],

  components: {
    PsPromotion
  },
  computed: {},
  mounted () {},

  methods: {}
}
</script>
<style lang="stylus" scoped>
.casino-promotions-container
  background var(--pages-bgr)
  padding 20px 10px 40px 10px !important
  border-radius var(--pages-border-radius) !important
</style>



// WEBPACK FOOTER //
// src/components/igaming/partials/CasinoPromotions.vue